/* global swal, _, angular*/
import './style.less';
import { isEmpty, cloneDeep } from 'lodash';
import { deliveryMethods } from '@prolaera/library';

export default function($log, $q, $stateParams, CategoryClass, ProfileClass, ApiClass, $rootScope, $state) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.cancel = () => {
    if (!$stateParams.eventId) return $rootScope.$back();
    vm.formData = cloneDeep(vm.ngModel);
    vm.edit = false;
  };

  vm.submit = formData => {
    if (formData.event_id) return updateEvent(formData);
    else createEvent(formData);
  };

  const createParams = formData => {
    const company_id = ProfileClass.company_id;

    if (!formData.updates) formData.updates = [{ profile_uid: $stateParams.id, time: new Date().getTime() }];
    else formData.updates.push({ profile_uid: $stateParams.id, time: new Date().getTime() });

    Object.keys(formData.sponsors).forEach(sponsor => {
      if (!formData.sponsors[sponsor] || formData.sponsors[sponsor].length < 1) delete formData.sponsors[sponsor];
    });

    formData.delivery_uid = parseInt(formData.delivery_uid);

    return {
      course_id: 'external',
      course_name: formData.course_name,
      delivery_date: new Date(formData.delivery_date).toISOString(),
      delivery_method: formData.delivery_method,
      delivery_location: formData.delivery_location,
      event_id: formData.event_id || $stateParams.eventId || false,
      hours: formData.hours,
      hours_basic: formData.hours_basic,
      sponsors: formData.sponsors,
      sponsors_types: formData.sponsors_types,
      updates: formData.updates,
      access: [company_id],
      company_id: company_id,
      active: false,
      archive: false,
      report_submitted: false,
      pdf_uploaded: false,
      external: true
    };
  };

  function createEvent(formData) {
    vm.submitBtn = true;
    const params = createParams(formData);

    return ApiClass.eventsPut({ manage: true }, { event: params })
      .then(({ data: { event } }) => {
        vm.submitBtn = false;
        vm.ngModel = cloneDeep({ ...formData, event_id: event.event_id });
        vm.edit = false;
        $state.go(
          '.',
          {
            id: $stateParams.id,
            eventid: event.event_id
          },
          { notify: false }
        );
      })
      .catch(error => {
        $log.error(error);
      });
  }

  function updateEvent(formData) {
    vm.submitBtn = true;
    const params = createParams(formData);

    return ApiClass.eventsIdPatch({ id: params.event_id, manage: true }, { event: params })
      .then(() => {
        vm.submitBtn = false;
        vm.ngModel = cloneDeep(formData);
        vm.edit = false;
      })
      .catch(error => {
        if (error === 'exit') return;
        swal('Error', error, 'error');
      });
  }

  const template = {
    sponsors: {},
    sponsors_types: {},
    delivery_date: new Date(Date.now()),
    hours: [
      {
        category_id: '',
        credits: '',
        subject_area: ''
      }
    ]
  };

  function activate() {
    $log.debug('Add Hour Component Activated');
    vm.loaded = false;
    vm.error = {};

    vm.stateParams = $stateParams;
    vm.collaspedCustomAccreditation = false;
    vm.dateOptions = { minDate: new Date(1980, 1, 1), maxDate: new Date().setYear(new Date().getFullYear() + 1) };

    vm.completionDate = {
      opened: false
    };

    if (isEmpty(vm.ngModel)) {
      vm.formData = cloneDeep(template);
      vm.ngModel = vm.formData;
    } else {
      vm.formData = cloneDeep(vm.ngModel);
      vm.formData.delivery_date = new Date(vm.formData.delivery_date);
    }

    $q.all([CategoryClass.loadCategories()])
      .then(([categories]) => {
        vm.categories = categories.arr;
        vm.categoryDict = categories.obj;
        vm.deliveryMethods = deliveryMethods;

        vm.loaded = true;
      })
      .catch(error => {
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/external/edit/controller.js